import $ from "jquery";

export default class Feature {
  constructor() {
    this.example = 'example';
  }

  init() {
    this.example = 'initialized';
    console.log("init this ************");
  }
}
